import React, { useState } from 'react';

import gameboxImage from '../myContent/WebsiteLogo.png';
import gamebox3dImage from '../myContent/3dGameBoxSmall.png';

import webAndell from '../myContent/webAndell.png';
import webGarson from '../myContent/webGarson.png';
import webSigg from '../myContent/webSigg.png';
import webTeelu from '../myContent/webTeelu.png';
import webTorgen from '../myContent/webTorgen.png';

import health from '../myContent/heart.png';
import coins from '../myContent/coins.png';

import '../App.css';
import { Button, Card, Col, ConfigProvider, Progress, Row, Switch } from 'antd';
import Meta from 'antd/es/card/Meta';


const BoardGamePage: React.FC = () => {

    const AndellStartingMaxHealth = 38;
    const GarsonStartingMaxHealth = 36;
    const SiggStartingMaxHealth = 40;
    const TeeluStartingMaxHealth = 34;
    const TorgentartingMaxHealth = 42;

    const AndellAdeptAbility = "Swooping Crows";
    const AndellLegendAbility = "Vines of Wrath";
    const GarsonAdeptAbility = "Perforate";
    const GarsonLegendAbility = "Toxin Vial";
    const SiggAdeptAbility = "Battle Focus";
    const SiggLegendAbility = "Devastating Hit";
    const TorgenAdeptAbility = "Finders Keepers";
    const TorgenLegendAbility = "Crippling Impact";
    const TeeluAdeptAbility = "Council's Blessing";
    const TeeluLegendAbility = "Mind Breaker";

    const [getActivePlayer, setActivePlayer] = useState("Andell");
    const [getAndellIsChosen, setAndellIsChosen] = useState(true);
    const [getGarsonIsChosen, setGarsonIsChosen] = useState(false);
    const [getSiggIsChosen, setSiggIsChosen] = useState(false);
    const [getTeeluIsChosen, setTeeluIsChosen] = useState(false);
    const [getTorgenIsChosen, setTorgenIsChosen] = useState(false);

    const [getHealth, setHealth] = useState(AndellStartingMaxHealth);
    const [getMaxHealth, setMaxHealth] = useState(AndellStartingMaxHealth);
    const [getIsDefeated, setIsDefeated] = useState(false);

    const [getXP, setXP] = useState(0);
    const [getLegendaryRank, setLegendaryRank] = useState(0);

    const [getCoins, setCoins] = useState(0);

    const [getAdeptAbilityName, setAdeptAbilityName] = useState(AndellAdeptAbility);
    const [getLegendAbilityName, setLegendAbilityName] = useState(AndellLegendAbility);


    function chooseAndell() {
        setActivePlayer("Andell");
        setAdeptAbilityName(AndellAdeptAbility);
        setLegendAbilityName(AndellLegendAbility);
        setHealth(AndellStartingMaxHealth);
        setMaxHealth(AndellStartingMaxHealth)
        dontChooseOthers();
        setAndellIsChosen(true);
    };
    function chooseGarson() {
        setActivePlayer("Garson");
        setAdeptAbilityName(GarsonAdeptAbility);
        setLegendAbilityName(GarsonLegendAbility);
        setHealth(GarsonStartingMaxHealth);
        setMaxHealth(GarsonStartingMaxHealth)
        dontChooseOthers();
        setGarsonIsChosen(true);
    };
    function chooseSigg() {
        setActivePlayer("Sigg");
        setAdeptAbilityName(SiggAdeptAbility);
        setLegendAbilityName(SiggLegendAbility);
        setHealth(SiggStartingMaxHealth);
        setMaxHealth(SiggStartingMaxHealth)
        dontChooseOthers();
        setSiggIsChosen(true);
    };
    function chooseTeelu() {
        setActivePlayer("Teelu");
        setAdeptAbilityName(TeeluAdeptAbility);
        setLegendAbilityName(TeeluLegendAbility);
        setHealth(TeeluStartingMaxHealth);
        setMaxHealth(TeeluStartingMaxHealth)
        dontChooseOthers();
        setTeeluIsChosen(true);
    };
    function chooseTorgen() {
        setActivePlayer("Torgen");
        setAdeptAbilityName(TorgenAdeptAbility);
        setLegendAbilityName(TorgenLegendAbility);
        setHealth(TorgentartingMaxHealth);
        setMaxHealth(TorgentartingMaxHealth)
        dontChooseOthers();
        setTorgenIsChosen(true);
    };
    function dontChooseOthers() {
        setAndellIsChosen(false);
        setGarsonIsChosen(false);
        setSiggIsChosen(false);
        setTeeluIsChosen(false);
        setTorgenIsChosen(false);
    };
    function healthUp(heal: number): void {
        if (getHealth + heal >= getMaxHealth) {
            setHealth(getMaxHealth);
        }
        else { setHealth(getHealth + heal); }

        if (getHealth === 0) {
            setIsDefeated(false)
        }

    };
    function healthToMax(): void {
        setHealth(getMaxHealth);
        setIsDefeated(false)
    };
    function healthDown(damage: number): void {
        if (getHealth - damage === 0) {
            setIsDefeated(true);
        }
        if (getHealth - damage < 0) {
            setHealth(0);
            setIsDefeated(true);
            return;
        }
        setHealth(getHealth - damage);
    };
    function increaseXP(xp: number) {
        setXP(getXP + xp);

        if (getXP + xp >= 150 && getXP < 199) {

            if (getLegendaryRank !== 1) {
                setLegendaryRank(1);
                setMaxHealth(getMaxHealth + 1);
            }

        }
        if (getXP + xp >= 200 && getXP < 249) {
            if (getLegendaryRank !== 2) {
                setLegendaryRank(2);
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 250 && getXP < 299) {
            if (getLegendaryRank !== 3) {
                setLegendaryRank(3)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 300 && getXP < 349) {
            if (getLegendaryRank !== 4) {
                setLegendaryRank(4)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 350 && getXP < 399) {
            if (getLegendaryRank !== 5) {
                setLegendaryRank(5)
                setMaxHealth(getMaxHealth + 1);
            }
        }

        if (getXP + xp >= 400 && getXP < 449) {
            if (getLegendaryRank !== 6) {
                setLegendaryRank(6)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 450 && getXP < 499) {
            if (getLegendaryRank !== 7) {
                setLegendaryRank(7)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 500 && getXP < 549) {
            if (getLegendaryRank !== 8) {
                setLegendaryRank(8)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 550 && getXP < 599) {
            if (getLegendaryRank !== 9) {
                setLegendaryRank(9)
                setMaxHealth(getMaxHealth + 1);
            }
        }
        if (getXP + xp >= 600 && getXP < 649) {
            if (getLegendaryRank !== 10) {
                setLegendaryRank(10)
                setMaxHealth(getMaxHealth + 1);
            }
        }

    };
    function coinsUp(coin: number): void {
        setCoins(getCoins + coin);
    };
    function coinsDown(coin: any): void {
        if (getCoins - coin < 0) {
            setCoins(0);
            return;
        }
        setCoins(getCoins - coin);
    };
    function downloadRules(): void {
        fetch('TheHeroesOfCragknollRuleBookV1.0.pdf').then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'TheHeroesOfCragknollRuleBookV1.0.pdf';
                alink.click();
            })
        })
    }


    return (
        <div className="App">
            <header className="App-header">

                This is the board game page!

                <a
                    className="App-link"
                    href="/"
                    rel="noopener noreferrer">
                    Go back
                </a>

                <img src={gameboxImage} alt="gameImage" className='width400 padThatBottom myLogo' />
                <p className='width400'>
                    The Heroes of Cragknoll is an action-adventure game that can be played solo or with up to 4 players.
                    Take charge of battle-ready heroes who venture out on increasingly perilous quests.
                    Overcome obstacles, find gear, spend hard-earned coin, and battle fearsome foes!
                </p>


                <div className='padThatBottom'>
                    <Card className='width395' >
                        <Meta title="Web Companion" description="Choose your hero" className='padThatBottom' />
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimaryHover: '#00b96b'
                                },
                            }}>
                            <Button type="primary" onClick={chooseAndell} className={`${getActivePlayer === "Andell" ? 'activePlayerGreen' : ''}`.trim()}>
                                Andell
                            </Button>
                            <Button type="primary" onClick={chooseGarson} className={`${getActivePlayer === "Garson" ? 'activePlayerGreen' : ''}`.trim()}>
                                Garson
                            </Button>
                            <Button type="primary" onClick={chooseSigg} className={`${getActivePlayer === "Sigg" ? 'activePlayerGreen' : ''}`.trim()}>
                                Sigg
                            </Button>
                            <Button type="primary" onClick={chooseTeelu} className={`${getActivePlayer === "Teelu" ? 'activePlayerGreen' : ''}`.trim()}>
                                Teelu
                            </Button>
                            <Button type="primary" onClick={chooseTorgen} className={`${getActivePlayer === "Torgen" ? 'activePlayerGreen' : ''}`.trim()}>
                                Torgen
                            </Button>
                        </ConfigProvider>




                        {getActivePlayer !== "" && (
                            <div>

                                <div>
                                    {getAndellIsChosen && (
                                        <img src={webAndell} alt="webAndell" className={`${getIsDefeated ? 'dead' : 'webCharacters'}`.trim()} />

                                    )}
                                    {getGarsonIsChosen && (

                                        <img src={webGarson} alt="webGarson" className={`${getIsDefeated ? 'dead' : 'webCharacters'}`.trim()} />

                                    )}
                                    {getSiggIsChosen && (

                                        <img src={webSigg} alt="webSigg" className={`${getIsDefeated ? 'dead' : 'webCharacters'}`.trim()} />

                                    )}
                                    {getTeeluIsChosen && (

                                        <img src={webTeelu} alt="webTeelu" className={`${getIsDefeated ? 'dead' : 'webCharacters'}`.trim()} />

                                    )}
                                    {getTorgenIsChosen && (

                                        <img src={webTorgen} alt="webTorgen" className={`${getIsDefeated ? 'deadWider' : 'webCharactersWider'}`.trim()} />

                                    )}
                                    {getIsDefeated && (
                                        <div className='defeatText'>
                                            <strong>Defeated!</strong>
                                        </div>
                                    )}

                                </div>







                                <Row className='padThatBottom'>
                                    <Col span={24} className='paddy'>


                                        <Row>

                                            <ConfigProvider
                                                theme={{
                                                    token: {
                                                        colorPrimaryHover: '#52c41a' //heal color
                                                    },
                                                }}>


                                                <Col span={18} push={6}>
                                                    Heal:
                                                    <Button type="primary" className='healColor marginy' onClick={(e) => { healthToMax(); }}>
                                                        Max
                                                    </Button>
                                                    <Button type="primary" className='healColor marginy' onClick={(e) => { healthUp(10); }}>
                                                        10
                                                    </Button>
                                                    <Button type="primary" className='healColor marginy' onClick={(e) => { healthUp(5); }}>
                                                        5
                                                    </Button>
                                                    <Button type="primary" className='healColor marginy' onClick={(e) => { healthUp(1); }}>
                                                        1
                                                    </Button>


                                                    <Row>
                                                        <ConfigProvider
                                                            theme={{
                                                                token: {
                                                                    colorPrimaryHover: '#d9363e' //suffer color
                                                                },
                                                            }}
                                                        >
                                                            Suffer Damage:
                                                            <Button type="primary" className='damageColor marginy' onClick={(e) => { healthDown(5); }}>
                                                                5
                                                            </Button>
                                                            <Button type="primary" className='damageColor marginy' onClick={(e) => { healthDown(1); }}>
                                                                1
                                                            </Button>
                                                        </ConfigProvider>

                                                    </Row>

                                                </Col>
                                                <Col span={6} pull={18}>
                                                    <img src={health} alt="health" className='iconSize' />
                                                    <strong>Current Health: {getHealth}</strong>
                                                </Col>
                                            </ConfigProvider>
                                        </Row>
                                    </Col>
                                </Row>




                                <Row>

                                    <Col span={18} push={6}>
                                        <ConfigProvider
                                            theme={{
                                                token: {
                                                    colorPrimaryHover: '#d59b44'
                                                },
                                            }}
                                        >

                                            <Row>
                                                Find Coins:
                                                <Button type="primary" className='coinColor marginy' onClick={(e) => { coinsUp(5); }}>
                                                    5
                                                </Button>
                                                <Button type="primary" className='coinColor marginy' onClick={(e) => { coinsUp(1); }}>
                                                    1
                                                </Button>

                                            </Row>
                                            <Row>
                                                Lose Coins:
                                                <Button type="primary" className='coinColorLose marginy' onClick={(e) => { coinsDown(5); }}>
                                                    5
                                                </Button>
                                                <Button type="primary" className='coinColorLose marginy' onClick={(e) => { coinsDown(1); }}>
                                                    1
                                                </Button>

                                            </Row>


                                        </ConfigProvider>

                                    </Col>

                                    <Col span={6} pull={18}>
                                        <p>
                                            <img src={coins} alt="coins" className='iconSize' />
                                            <strong>Current Coins: {getCoins}</strong>
                                        </p>

                                    </Col>

                                </Row>










                                <div>






                                    <strong>Current XP: {getXP} </strong>
                                    {getXP < 50 && (
                                        <div>
                                            <Progress percent={getXP / 50 * 100} size="small" showInfo={false} />
                                        </div>
                                    )}


                                    {getXP >= 50 && getXP < 99 && (
                                        <div>
                                            <Progress percent={(getXP - 50) / 50 * 100} size="small" showInfo={false} />

                                            <strong>Veteran! </strong>
                                        </div>
                                    )}
                                    {getXP >= 100 && getXP < 149 && (
                                        <div>
                                            <Progress percent={(getXP - 100) / 50 * 100} size="small" showInfo={false} />
                                            <strong>Legend! </strong>
                                        </div>
                                    )}

                                    {getXP >= 150 && (
                                        <div>
                                            <strong>Legendary rank: {getLegendaryRank} </strong>
                                        </div>
                                    )}

                                </div>
                                Gain XP:
                                <Button type="primary" className='marginy' onClick={(e) => { increaseXP(10); }}>
                                    10
                                </Button>
                                <Button type="primary" className='marginy' onClick={(e) => { increaseXP(5); }}>
                                    5
                                </Button>
                                <Button type="primary" className='marginy' onClick={(e) => { increaseXP(1); }}>
                                    1
                                </Button>

                                <p></p>
                                <Row>
                                    <Col span={18} push={6}>

                                        {getAdeptAbilityName}:

                                        <Row>
                                            <Col span={24}>
                                                <Switch defaultChecked={true} className='marginy' />
                                                <Switch defaultChecked={true} className='marginy' />
                                                <Switch defaultChecked={true} className='marginy' />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24}>
                                                <Switch defaultChecked={true} className='marginy' />
                                                <Switch defaultChecked={true} className='marginy' />
                                                <Switch defaultChecked={true} className='marginy' />
                                            </Col>

                                        </Row>



                                        <p></p>
                                        {getXP >= 100 && (
                                            <div>
                                                {getLegendAbilityName}:
                                                <Row>

                                                    <Col span={24}>
                                                        <Switch defaultChecked={true} className='marginy' />
                                                        <Switch defaultChecked={true} className='marginy' />
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Switch defaultChecked={true} className='marginy' />
                                                        <Switch defaultChecked={true} className='marginy' />
                                                    </Col>
                                                </Row>


                                            </div>
                                        )}

                                    </Col>

                                    <Col span={6} pull={18}>
                                        <strong>Skills</strong>
                                    </Col>


                                </Row>



                            </div>
                        )}



                    </Card>
                </div>

                <div className='padThatBottom'>
                    <Card title="Boardgame rules in PDF" className='height300 width395 padThatBottom'>
                        <Row>
                            <Col span={24}>
                                <img src={gamebox3dImage} alt="3dgameboxImage" className='width160' />
                            </Col>
                            <Col span={24}>
                                <Button type="primary" onClick={downloadRules}>
                                    Download Rulebook
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>


                <div className='padThatBottom'>
                    <Card title="How to play / Game overview video" className='height300 width395 '>
                        <iframe width="300" height="200"
                            src="https://www.youtube.com/embed/tg6xGCTSeX4"
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
                        </iframe>
                    </Card>
                </div>


                <div className='padThatBottom'>
                    <Card title="Tabletop Simlulator mod" className='height300 width395 padThatBottom'>
                        Now playable here:
                        <a
                            className="App-link"
                            href="https://steamcommunity.com/sharedfiles/filedetails/?id=2996659304"
                            target="_blank"
                            rel="noopener noreferrer">
                            Tabletop simulator workshop
                        </a>
                    </Card>
                </div>


            </header>
        </div>
    );
}

export default BoardGamePage;
